<mat-form-field class="table-filter">
  <mat-label>{{ filterLabel | translate }}</mat-label>
  <input matInput [formControl]="inputControl" />
</mat-form-field>
